import { Instagram, Mail } from "lucide-react";
import { scrollToId } from "../lib/lenis";

const LINKS = [
  ["services", "Services"],
  ["proof", "Backstage"],
  ["about", "About"],
  ["technique", "Method"],
  ["retreat", "Zanzibar Retreat"],
  ["foundation", "Foundation"],
  ["quote", "Request a Quote"],
];

export const Footer = () => (
  <footer className="relative border-t border-white/10 bg-ink" data-testid="footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16">
      <div className="flex flex-col lg:flex-row justify-between gap-12">
        <div className="max-w-sm">
          <div className="flex items-center gap-4">
            <img src="/images/et-logo.png" alt="Elite Therapeutics logo" className="h-16 w-16 sm:h-20 sm:w-20 object-contain" data-testid="footer-logo" />
            <em className="font-serif italic text-base sm:text-lg text-gold leading-tight">
              Wellness<br />in Motion
            </em>
          </div>
          <p className="mt-5 text-sm text-mute leading-relaxed">
            Fascia-first therapeutic bodywork for corporations, events, tours and private clients.
            Alberta · Montreal.
          </p>
          <p className="mt-4 font-mono text-[9px] uppercase tracking-[0.2em] text-gold" data-testid="footer-accreditations">
            RMT 2200 hrs · NHPC Registered · FQM Registered
          </p>
          <div className="mt-5 flex flex-col gap-2" data-testid="footer-contact">
            <a href="mailto:akamba81@gmail.com" data-testid="footer-email-link"
              className="inline-flex items-center gap-2.5 text-sm text-ivory/85 hover:text-gold transition-colors w-fit">
              <Mail className="h-4 w-4 text-gold" aria-hidden="true" /> akamba81@gmail.com
            </a>
            <a href="https://instagram.com/elite_therapeutics" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"
              className="inline-flex items-center gap-2.5 text-sm text-ivory/85 hover:text-gold transition-colors w-fit">
              <Instagram className="h-4 w-4 text-gold" aria-hidden="true" /> @elite_therapeutics
            </a>
          </div>
        </div>
        <nav className="flex flex-col gap-3" aria-label="Footer" data-testid="footer-nav">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)}
              className="text-left font-mono text-[11px] uppercase tracking-[0.2em] text-mute hover:text-gold transition-colors">
              {label}
            </button>
          ))}
        </nav>
      </div>

      <p className="mt-16 font-serif font-light text-[clamp(2.6rem,8vw,6rem)] leading-none tracking-tight text-ivory/10 select-none" aria-hidden="true">
        ELITE THERAPEUTICS
      </p>
      <div className="mt-10 flex flex-col sm:flex-row justify-between gap-3 border-t border-white/10 pt-6">
        <p className="font-mono text-[9px] uppercase tracking-[0.2em] text-mute/60">
          © {new Date().getFullYear()} Elite Therapeutics · Ariane Kamba. All rights reserved.
        </p>
        <p className="font-mono text-[9px] uppercase tracking-[0.2em] text-mute/60">
          Wellness in motion.
        </p>
      </div>
    </div>
  </footer>
);
